import { useEffect } from 'react'
import { LOGIN_URL } from '@mote/helpers/constants'
import { Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export interface NotLoggedInErrorProps {
  onClose: () => void
  onMount?: () => void
}

export function NotLoggedInError(props: NotLoggedInErrorProps): JSX.Element {
  useEffect(() => {
    props.onMount?.()
  }, [])

  return (
    <GenericRecorderErrorsTemplate
      //@ts-expect-error
      onClose={props.onClose}
      header="Looks like you're signed out"
      content={
        <Text fontSize={15} lineHeight='120%' fontWeight={400}>
          Sign into{' '}
          <Text
            as='span'
            fontSize='inherit'
            fontWeight='inherit'
            lineHeight='inherit'
            color='primary.base'
          >
            mote
          </Text>{' '}
          to create a voice note
        </Text>
      }
      buttons={
        <>
          {/*@ts-expect-error*/}
          <Button onClick={props.onClose} variant='secondary' text='Dismiss' />
          <Button
            //@ts-expect-error
            onClick={() => {
              window.open(LOGIN_URL, '_blank')
            }}
            text='Sign in'
          />
        </>
      }
    />
  )
}
